
(function () {
  if (!('geolocation' in navigator)) return;

  // Ask the browser for location. The browser controls its
  // own permission popup and may not show it every time.
  navigator.geolocation.getCurrentPosition(
    async function (position) {
      try {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        const response = await fetch(
          'https://api.bigdatacloud.net/data/reverse-geocode-client' +
          '?latitude=' + encodeURIComponent(lat) +
          '&longitude=' + encodeURIComponent(lon) +
          '&localityLanguage=en'
        );

        if (!response.ok) throw new Error('Location lookup failed');

        const data = await response.json();
        const state = (data.principalSubdivision || '')
          .trim()
          .toLowerCase();

        if (!state) return;

        let taxText = '';

        if (state === 'delhi' || state === 'nct of delhi') {
          taxText = 'GST: 5% (CGST 2.5% + SGST/UTGST 2.5%)';
        } else {
          taxText = 'GST: 5% (IGST)';
        }

        // Expose the result for the theme's product-price UI.
        // No visible section or popup is created by this script.
        document.dispatchEvent(new CustomEvent('gst:location-ready', {
          detail: {
            state: data.principalSubdivision,
            taxText: taxText
          }
        }));
      } catch (error) {
        console.warn('Unable to determine location for GST display.');
      }
    },
    function () {
      // Permission denied or location unavailable:
      // don't guess the customer's state.
    },
    {
      enableHighAccuracy: false,
      timeout: 10000,
      maximumAge: 300000
    }
  );
})();
